// TODO @consumer: Move this to global components

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
  className: PropTypes.string,
};

const Angle = ({ direction = 'down', className }) => {
  const classes = classNames({
    angle: true,
    [`angle-${direction}`]: true,
    [className]: !!className,
  });

  return (
    <span className={classes}>
      <span className="angle-icon" />
    </span>
  );
};

Angle.propTypes = propTypes;

export default Angle;
